import NotificationStatus from './NotificationStatus'

export default NotificationStatus
